import type { QaReviewKpi } from '../../../../schemas/qaReviewKpis.schemas';
import type { UserType } from '../../../../types/user.type';

export function getQaReviewMatrix(reviews: QaReviewKpi[], users: Pick<UserType, 'id' | 'fullName'>[]) {
    const names = new Map(users.map((user) => [user.id, user.fullName]));
    const owners = new Set<number>();
    const reviewers = new Map<
        number,
        {
            id: number;
            label: string;
            counts: Map<number, number>;
            total: number;
        }
    >();

    for (const { qaUserId, updateOwnerId, reviewedUpdates } of reviews) {
        owners.add(updateOwnerId);
        let reviewer = reviewers.get(qaUserId);
        if (!reviewer) {
            reviewer = { id: qaUserId, label: names.get(qaUserId) || String(qaUserId), counts: new Map(), total: 0 };
            reviewers.set(qaUserId, reviewer);
        }
        reviewer.counts.set(updateOwnerId, (reviewer.counts.get(updateOwnerId) ?? 0) + reviewedUpdates);
        reviewer.total += reviewedUpdates;
    }

    const compareUsers = (a: { id: number; label: string }, b: { id: number; label: string }) =>
        a.label.localeCompare(b.label) || a.id - b.id;

    return {
        owners: Array.from(owners, (id) => ({ id, label: names.get(id) || String(id) })).sort(compareUsers),
        reviewers: Array.from(reviewers.values()).sort(compareUsers),
    };
}

export function formatQaReviewPercentage(count: number, total: number): string {
    const percentage = total === 0 ? 0 : Math.round((count / total) * 1000) / 10;
    return `${percentage}%`;
}
